import { render, staticRenderFns } from "./AddVisitDialog.vue?vue&type=template&id=5a45dd56&scoped=true"
import script from "./AddVisitDialog.vue?vue&type=script&lang=ts"
export * from "./AddVisitDialog.vue?vue&type=script&lang=ts"
import style0 from "./AddVisitDialog.vue?vue&type=style&index=0&id=5a45dd56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a45dd56",
  null
  
)

export default component.exports